import { useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { useFormContext } from 'react-hook-form'
import { Radio } from '@solides/management-util-ui'

import type { Option } from 'types/global'

interface Props {
  name: string
  label?: string
  className?: string
  options: Option[]
  triggerOnChange?: (value: string) => void
}

export const Radios = ({
  name,
  label = '',
  className = '',
  options = [],
  triggerOnChange = undefined
}: Props) => {
  const { getValues, setValue } = useFormContext()
  const [checked, setChecked] = useState<string>(getValues(name) || '')

  const handleCheckedRadio = (value: string): void => {
    setChecked(value)
    setValue(name, value)
    triggerOnChange && triggerOnChange(value)
  }

  return (
    <fieldset
      className={twMerge('flex flex-col gap-1 w-full items-start', className)}
    >
      {label && (
        <label htmlFor={name} className="text-body2 font-regular">
          {label}
        </label>
      )}
      <div className="flex items-center gap-x-4">
        {options.map(option => (
          <Radio
            id={option.value + name}
            key={option.value + name}
            label={option.text}
            value={option.value}
            checked={checked === option.value}
            onChange={() => handleCheckedRadio(option.value)}
          />
        ))}
      </div>
    </fieldset>
  )
}
